<script module lang="ts">
	export enum BadgeType {
		CIRCULAR,
		ROUNDED_SQUARE
	}
	export enum BadgeColor {
		RED,
		MUTED,
		WEAK
	}
</script>

<script lang="ts">
	interface Props {
		text: string
		badgeType?: BadgeType
		badgeColor?: BadgeColor
	}

	let { text, badgeType = BadgeType.CIRCULAR, badgeColor = BadgeColor.RED }: Props = $props()

	const isRounded: boolean = $derived(badgeType === BadgeType.ROUNDED_SQUARE)
</script>

<div
	class={isRounded ? 'badge-common rounded-square-wrapper' : 'badge-common badge'}
	class:bg-red={badgeColor === BadgeColor.RED}
	class:bg-muted={badgeColor === BadgeColor.MUTED}
	class:bg-weak={badgeColor === BadgeColor.WEAK}
>
	<div class={isRounded ? 'rounded-square-inner' : ''}>
		<div
			class={isRounded ? 'rounded-square-text' : 'badge-text'}
			class:text-muted={badgeColor === BadgeColor.MUTED}
		>
			{text}
		</div>
	</div>
</div>

<style lang="postcss">
	/* Shared container class */
	.badge-common {
		@apply inline-flex justify-center items-center;
	}

	/* CIRCULAR variant */
	.badge {
		@apply h-6 min-w-6 px-2 rounded-2xl gap-1;
	}

	.bg-red {
		@apply bg-[#e4485b];
	}

	.bg-muted {
		@apply bg-[#FFFFFF14];
	}

	.bg-weak {
		@apply bg-[#00498011];

		.badge-text {
			@apply text-[#001D33B2];
		}
	}

	.badge-text {
		@apply flex-1 text-center justify-start text-white text-sm font-normal leading-tight;
	}

	/* ROUNDED_SQUARE variant */
	.rounded-square-wrapper {
		@apply w-5 h-5 rounded flex-col;
	}

	.rounded-square-inner {
		@apply w-4 h-4 flex flex-col justify-center items-center gap-2.5;
	}

	.rounded-square-text {
		@apply self-stretch text-center text-white text-xs font-normal leading-none;
	}

	.text-muted {
		@apply text-[#FFFFFFC7];
	}
</style>
